// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Images/Misc/BG_Under Maintenance.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#M1 {
    width: 100vw;
    height: 100%;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;

    z-index: 5;
}

#M2 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    
    position: absolute;

    top: 35%;
    right: 12%;

    width: 50%;
    height: 50%;

    text-align: center;
}

#MaintenanceSpan1 {
    /* position: absolute; */

    width: 120%;

    /* top: 30%;
    left: 60%; */
    /* font: 9.2cqh Diesel; */
    font: 5.2cqw Diesel;
    color: white;
}

#MaintenanceSpan2 {
    /* position: absolute; */

    width: 120%;
    /* top: 47%; */
    font: 5cqh MyriadPro-Regular;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Maintenance.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;;IAEZ,yDAA2E;IAC3E,sBAAsB;;IAEtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET,kBAAkB;;IAElB,QAAQ;IACR,UAAU;;IAEV,UAAU;IACV,WAAW;;IAEX,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;;IAExB,WAAW;;IAEX;gBACY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;;IAExB,WAAW;IACX,cAAc;IACd,4BAA4B;IAC5B,YAAY;AAChB","sourcesContent":["#M1 {\r\n    width: 100vw;\r\n    height: 100%;\r\n\r\n    background-image: url(\"../../public/Images/Misc/BG_Under\\ Maintenance.jpg\");\r\n    background-size: cover;\r\n\r\n    z-index: 5;\r\n}\r\n\r\n#M2 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 50px;\r\n    \r\n    position: absolute;\r\n\r\n    top: 35%;\r\n    right: 12%;\r\n\r\n    width: 50%;\r\n    height: 50%;\r\n\r\n    text-align: center;\r\n}\r\n\r\n#MaintenanceSpan1 {\r\n    /* position: absolute; */\r\n\r\n    width: 120%;\r\n\r\n    /* top: 30%;\r\n    left: 60%; */\r\n    /* font: 9.2cqh Diesel; */\r\n    font: 5.2cqw Diesel;\r\n    color: white;\r\n}\r\n\r\n#MaintenanceSpan2 {\r\n    /* position: absolute; */\r\n\r\n    width: 120%;\r\n    /* top: 47%; */\r\n    font: 5cqh MyriadPro-Regular;\r\n    color: white;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
